module.exports = __webpack_public_path__ + "static/media/SunnyCal.51993195.png";